import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { AuditService } from 'app/audit/services/audit.service';
import { AuditListModel } from 'app/audit/models/audit-list.model';
import { ColumnSortedEvent } from 'app/core/models/column-sorted-model';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { SortService } from 'app/core/services/sort.service';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'app-audit-list',
    templateUrl: './audit-list.component.html',
    styleUrls: ['./audit-list.component.css']
})
export class AuditListComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    audits: AuditListModel[];
    auditList: AuditListModel[];
    lastSort: ColumnSortedEvent;
    filterForm: FormGroup;
    filterTextControl: FormControl;

    constructor(
        private auditService: AuditService,
        private fb: FormBuilder,
        private sortService: SortService
    ) { }

    ngOnInit() {
        this.headerTitle = { title: 'Audits' }

        this.auditService.getAll().subscribe(
            audits => {
                this.audits = audits;
                this.auditList = audits;
            },
            error => this.errors = error.errorList
        );

        this.filterTextControl = this.fb.control('');
        this.filterForm = this.fb.group({
            filterText: this.filterTextControl
        });

        this.filterTextControl.valueChanges.pipe(debounceTime(250)).subscribe(newValue => {
            this.auditList = this.sortService.filterAndSortlist(this.audits, newValue, this.lastSort);
        });
    }
}
